import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Floating chatbot button that appears only on /portfolio-manager/* routes.
 * Fixed position bottom-right. Clicking navigates to the chat page.
 */
export function FloatingChatButton() {
  const location = useLocation()
  const navigate = useNavigate()

  // Only show on portfolio-manager routes, but NOT on the chat page itself
  const isPMRoute = location.pathname.startsWith('/portfolio-manager')
  const isChatPage = location.pathname === '/portfolio-manager/chat'

  if (!isPMRoute || isChatPage) return null

  return (
    <button
      onClick={() => navigate('/portfolio-manager/chat')}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[var(--color-accent)] text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 flex items-center justify-center text-2xl"
      title="Portfolio Chat"
      aria-label="Open portfolio chat"
    >
      💬
    </button>
  )
}
